export default __webpack_public_path__ + "static/media/logo-light1.38d98a69.png";